import { InlineResponse200 } from "@swagger/typescript-fetch-goflyer";
import { FrontPage } from "../../../../utils/constant/stringConstant";
import {
  toastExcelSuccess,
  toastExcelError,
} from "../../../../utils/pageUtil/toast";
import { resolveAuthToken } from "../../../../hooks/useAuthHeaders";

/**
 * Imports Excel data for flyer items using native fetch API instead of Swagger SDK.
 * Direct fetch implementation is used because the Swagger-generated SDK doesn't properly
 * support file upload functionality.
 *
 * @param {File} file - The Excel file containing flyer item data to be uploaded
 * @param {string} flyerItemListId - The ID of the flyer item list to associate with the imported items
 * @param {string[]} selectedCategories - Array of category IDs to assign to the imported items, may include special "FrontPage" category
 * @returns {Promise<boolean>} Returns true if import was successful, false otherwise
 */
export const importExcelFn = async (
  file: File,
  flyerItemListId: string,
  selectedCategories: string[]
): Promise<boolean> => {
  try {
    const selectedCategoryList = selectedCategories.filter(
      (category) => category !== FrontPage
    );
    const topSale = selectedCategories.find(
      (category) => category === FrontPage
    );
    const formData = new FormData();
    formData.append("file", file);
    formData.append("flyerItemListId", flyerItemListId);

    if (selectedCategoryList && selectedCategoryList.length > 0) {
      formData.append("gfFlyerItemCategoryIds", selectedCategoryList.join(","));
    }
    if (topSale) {
      formData.append("topSale", String(true));
    }

    const response = await fetch(
      `${process.env.REACT_APP_GOFLYER_API_END_POINT}/admin-flyer-item/upload-excel`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${resolveAuthToken() ?? ""}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to import Excel file");
    }

    const responseData: InlineResponse200 = await response.json();

    if (
      responseData.validationErrors &&
      responseData.validationErrors.length > 0
    ) {
      responseData.validationErrors.map((err) => {
        const message = `Row ${err.row}: ${err.field} - ${err.error} (Value: ${
          err.value || "empty"
        })`;
        toastExcelError(message);
      });
    }

    toastExcelSuccess(
      `Excel file imported successfully. Items processed: ${responseData.successCount} successful, ${responseData.failedCount} failed.`
    );
    return true;
  } catch (error) {
    console.error("Error importing Excel:", error);
    toastExcelError(
      `Failed to import Excel: ${
        error instanceof Error ? error.message : "Unknown error"
      }`
    );
    return false;
  }
};
